import { DialogUI } from '../Interface';
import { SimpleTaskPhoneForm } from './SimpleTaskPhoneForm';

const SimpleTaskPhoneFormDialog = ({ handleClose, changed, dialogData }) => {
  const { open, data } = dialogData;
  const { taskChanged, setTaskChanged } = changed;

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Új feladat létrehozása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
            mx: 1,
          },
        },
      }}
    >
      <div className="mt-3">
        <SimpleTaskPhoneForm
          dialog={{
            handleClose: handleClose,
            taskChanged: taskChanged,
            setTaskChanged: setTaskChanged,
            dialogData: data,
          }}
        />
      </div>
    </DialogUI>
  );
};

export default SimpleTaskPhoneFormDialog;
